import {Channels} from 'cl-api';
import * as _ from 'lodash';
import {Map} from 'immutable';
import {STATUS_FILTERS} from '../MyAccount/Listings/consts';
import {Location} from 'history';
import {TablesState} from 'cl-table/redux/actions';

const serverData = (window as any).___data;
// const templateData = serverData.template;
const userData = serverData && serverData.user;
function getAutoSaveId() {
  if (serverData) {
    const templates = serverData.templates.userTemplates[0];
    const autosave = templates.filter(template => template.name === 'Autosave');
    if (autosave.length) {
      return autosave[0].id;
    }
    return 0;
  }
  return 0;
}

const exported = {
  templates: {
    templateList: (serverData && serverData.templates.templateList) || [],
    categoryList: (serverData && serverData.templates.categoryList) || [],
    prefetchedTemplates: [],
    userTemplates: (serverData && serverData.templates.userTemplates) || [],
    autoSaveId: getAutoSaveId(),
    selectedTemplates: [],
    openedDialog: '',
    currentTemplate: '',
    snackbarData: {
      open: false,
      message: '',
      action: '',
      actionFunc: () => {},
    },
  },

  user: userData,

  upgrade: {
    couponStatus: serverData.couponStatus,
  },

  accountPage: serverData.accountPage && {
    ...serverData.accountPage,
    accounts: _.keyBy(serverData.accountPage.accounts, 'UserID'),
    amazonAccounts: _.keyBy(serverData.accountPage.amazonAccounts, 'amazonSellerId'),
  },

  general: {
    progress: {},
    ...serverData.general,
    windowBusy: false,
  },

  settings: serverData.settings,

  listingsPage: {
    listings: _.mapValues(serverData.listingsPage.listings, sellerData => {
      return _.mapValues(sellerData, (value, key) => {
        if (STATUS_FILTERS.indexOf(key) !== -1) {
          return {...value, listings: Map(value.listings)};
        }
        return value;
      });
    }),
    leftMenuOpen: true,
    editDescription: false,
    refreshingFromEbayPercent: {},
    refreshingFromEbay: {},
    findAndReplaceRequestIndex: 0,
    updatedTemplateS3VersionId: {},
  },

  images: {
    Images: {
      selectedImages: {},
      uploadFiles: [],
      searchFile: '',
      sort: {},
      snackbarData: {
        open: false,
        message: '',
        action: '',
        actionFunc: () => {},
      },
      view: '',
    },
    Icons: {
      sort: {},
      view: '',
    },
    DescriptionImages: {
      uploadFiles: [],
    },
    ProductImages: {
      uploadFiles: [],
    },
  },
  panel: {
    openedLazyPanels: [],
    openedStaticPanels: [],
  },

  templateTagSet: serverData.templateTagSet,

  ebayListing: {
    fieldsToRevise: {},
    fieldsToDelete: {},
    blurredFields: {},
  },
};

export type TemplateInfo = {
  id: number;
  name: string;
  createdAt: string;
  modifiedAt: string;
  thumbnailUrl: string;
  previewUrl: string;
};

export type EbayAccountType = {
  channel: Channels;
  UserID: string;
  numberOfCommonTextBlocks: number;
  activeListingsCount: number;
  tokenExpirationDate: string;
  quantitySyncEnabled: boolean;
  oAuthToken: boolean;
  first?: boolean;
};

export type AmazonAccountType = {
  channel: Channels;
  amazonSellerId: string;
  name: string;
  quantitySyncEnabled: boolean;
  marketplaceIds: string[];
};

export interface StoreState {
  ebayListing: {
    fieldsToRevise: any;
    listingData: any;
    fieldsToDelete: any;
    sellerPolicies: any;
  };
  listingsPage: any;
  accountPage: {
    accounts: {
      [accountName: string]: EbayAccountType;
    };
    amazonAccounts: {
      [accountName: string]: AmazonAccountType;
    };
    lastAmazonError: string;
  };
  general: {
    eBaySites: any[];
    amazonSites: any[];
    progress: {
      [taskKey: string]: {percent: number; done: boolean; stats: any; index: number};
    };
    supportLinks: {[linkName: string]: string};
    legacyUtmCampaign: boolean;
  };
  routing: {
    location: Location;
  };
  user: any;
  table: TablesState;
  form: any;
  templates: {
    templateList: object[];
    categoryList: string[];
    prefetchedTemplates: any;
    userTemplates: {
      [folderId: string]: TemplateInfo;
      default: TemplateInfo;
    };
  };
  panel: {
    dynamicElements: Map<string, any>;
  };
  images: {
    [resourceType: string]: {
      uploadFiles: any[];
    };
  };
}

export default exported;
export {userData as user};

export const {
  templates,
  upgrade,
  accountPage,
  general,
  settings,
  listingsPage,
  images,
  panel,
  templateTagSet,
  ebayListing,
} = exported;
